import { useQuery } from '@tanstack/react-query';
import axiosInstanceAnalyze from '@/axios/AxiosInstanceAnalyze';

interface MediaItem {
  fileId: string;
  url: string;
  type: string;
  transcriptionText?: string;
}

interface ConversationMedia {
  conversationId: string;
  respondentIndex: number;
  media: MediaItem[];
}

async function fetchQuestionMedia(
  projectId: string,
  questionId: string,
  filterId: string | null,
): Promise<ConversationMedia[]> {
  const params = filterId ? `?filter_id=${filterId}` : '';
  const { data } = await axiosInstanceAnalyze.get<ConversationMedia[]>(
    `/analyzer/results/${projectId}/perquestion/${questionId}/media${params}`,
  );
  return data;
}

export function useGetQuestionMedia(
  projectId?: string,
  questionId?: string,
  filterId?: string | null,
) {
  return useQuery({
    queryKey: ['questionMedia', projectId, questionId, filterId],
    queryFn: () => fetchQuestionMedia(projectId!, questionId!, filterId ?? null),
    enabled: !!projectId && !!questionId,
    staleTime: 5 * 60 * 1000, // 5 minutes — matches signed URL expiration
  });
}
